module.exports = __webpack_public_path__ + "static/media/sitemap.3a990637.xml";